export default class Formatters {
	DayOfWeekLong = ['Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota', 'Niedziela'];

	DayOfWeekShort = ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'No'];

	TimezoneString = `+0${-(new Date().getTimezoneOffset() / 60)}:00`;

	DayOfWeek(i, short = false) {
		return (this[`DayOfWeek${short ? 'Short' : 'Long'}`])[i];
	}

	Fixed(i, digits = 2, separator = ',', noZeroes = false) {
		if (typeof i === 'string' && i.indexOf(',') > -1) { i = i.replace(',', '.'); }
		i = Number(i);
		if (!i && i !== 0) { return i; }
		if (digits < 0) { return String(i).replace('.', separator); }
		return Number(i).toFixed(digits).replace('.', separator).replace(`${separator}00`, noZeroes ? '' : `${separator}00`);
	}

	NumberToHour(i) {
		i = String(i);
		return (i.length === 3) ? (`${i.slice(null, 1)}:${i.slice(1)}`) : (`${i.slice(null, 2)}:${i.slice(2)}`);
	}

	Date(d) {
		if (typeof d === 'number') { return new Date(d); }
		d = String(d);
		if (d.indexOf('.') > -1) { d = d.split('.')[0]; }
		if (d.indexOf('T') === -1) { d = d.split(' ').join('T'); }
		return new Date(d + this.TimezoneString);
	}

	NiceDate(d, month = 'short') {
		const o = { year: 'numeric', month, day: 'numeric' };
		return d.toLocaleString('pl-PL', o);
	}

	NiceDateTime(d, year = undefined) {
		const o = {
			year, month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric',
		};
		return d.toLocaleString('pl-PL', o);
	}

	Time(d) {
		const o = { hour: 'numeric', minute: 'numeric' };
		return d.toLocaleString('pl-PL', o);
	}

	AvatarLetters = function (s: string) {
		const ss = s.split(' ', 2);
		return (ss[0][0] || '') + (ss[1] ? (ss[1][0] || '') : '').replace('undefined', '');
	};

	NumberWithSpaces = function (n: number, nbsp: boolean) {
		return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, nbsp ? '&nbsp;' : ' ');
	};

	PluralForm = function (n: string | number, forms: string[], includeNumber = false, nbsp = false, fixFractions = true) {
		const one = forms[0];
		const few = forms[1];
		const many = forms[2];
		const none = forms[3];
		const fraction = forms[4];

		let suffix = many;
		n = parseInt(n as string, 10);
		if (n === 0 && includeNumber) { return none || `Brak ${suffix}`; }
		if (n > 0 && n < 5) { suffix = few; }
		if (n === 1) { suffix = one; }
		if (fraction && n > 0 && n < 1) { suffix = fraction; }

		if (fixFractions) {
			const string = String(n);
			const lastDigit = Number(string[string.length - 1]);
			if (n > 10 && string.indexOf('.') === -1 && (lastDigit > 1 && lastDigit < 5)) { suffix = few; }
		}

		return (includeNumber ? n + (nbsp ? '&nbsp;' : ' ') : '') + suffix;
	};

	static PluralForm = function (n: string | number, forms: string[], includeNumber = false, nbsp = false) {
		const one = forms[0];
		const few = forms[1];
		const many = forms[2];
		const none = forms[3];
		const fraction = forms[4];

		let suffix = many;
		n = parseInt(n as string, 10);
		if (n === 0 && includeNumber) { return none || `Brak ${suffix}`; }
		if (n > 0 && n < 5) { suffix = few; }
		if (n === 1) { suffix = one; }
		if (fraction && n > 0 && n < 1) { suffix = fraction; }
		return (includeNumber ? n + (nbsp ? '&nbsp;' : ' ') : '') + suffix;
	};

	PluralFormAlt = function (
		n: string | number,
		forms: string[],
		includeNumber = false,
		nbsp = false,
	) {
		const one = forms[0];
		const few = forms[1];
		const many = forms[2];
		const none = forms[3];
		const fraction = forms[4];

		n = parseFloat(n as string);
		let suffix = many;

		if (n === 0 && includeNumber) {
			return none || `Brak ${many}`;
		}

		const isFraction = !Number.isInteger(n);

		if (fraction && isFraction && n > 0) {
			suffix = fraction;
		} else if (n === 1) {
			suffix = one;
		} else {
			const intN = Math.floor(n);
			const lastDigit = intN % 10;
			const lastTwoDigits = intN % 100;

			if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
				suffix = many;
			} else if (lastDigit >= 2 && lastDigit <= 4) {
				suffix = few;
			} else {
				suffix = many;
			}
		}

		const numberPart = includeNumber ? n + (nbsp ? '&nbsp;' : ' ') : '';
		return numberPart + suffix;
	};

	AvatarColor = function (s: string) {
		let sss = 0;
		for (const ss of s) { sss = ss.charCodeAt(0) + ((sss << 5) - sss); }
		sss = (sss % 90) * 4;
		return `hsl(${sss}, 50%, 70%)`;
	};

	Distance = (a, b) => Math.sqrt((a[0] - b[0]) ** 2 + (a[1] - b[1]) ** 2);

	SubmitConfirm = (s = '') => {
		if (typeof s !== 'string') { s = 'ok'; }
		let param = '';
		if (s.indexOf('|') > -1) {
			s = s.split('|');
			param = s[1];
			s = s[0];
		}
		const m = this.SubmitConfirmMessage[s.toLowerCase()] || '';
		return m ? m.replace('%s', param) : this.SubmitConfirmMessage.fail;
	};

	RefundReason = (s: string) => {
		let result = s;
		switch (s) {
			case 'NoContact': result = 'Brak kontaktu, nie można się skontaktować ze zleceniodawcą'; break;
			case 'WrongPerson': result = 'Niewłaściwa osoba wskazana jako kontaktowa'; break;
			case 'Outdated': result = 'Zapytanie nieaktualne już przy pierwszym kontakcie'; break;
			case 'Duplicate': result = 'Duplikat zapytania, które już wcześniej zostało zakupione w Oferteo'; break;
			case 'DoNotOffer': result = 'Nie oferuje tej usługi/produktu lub w odległej lokalizacji'; break;
			case 'WrongLocation': result = 'Zlecenie w jest zbyt odległej lokalizacji'; break;
			case 'Violation': result = 'Naruszenie regulaminu Oferteo lub niezgodność zapytania z prawem'; break;
			default: result = s;
		}
		return result;
	};

	CooperationBadge = (s: string) => {
		let result = s;

		switch (s.toLowerCase()) {
			case 'debug': result = ''; break;
			case 'manual': result = ''; break;
			case 'qc': result = 'Szybki Kontakt'; break;
			case 'im': result = 'Polecanie'; break;
			case 'bc': result = 'Promowanie'; break;
			case 'confirmed': result = 'Potwierdziłeś współpracę'; break;
			case 'buyerconfirmed': result = 'Klient potwierdził współpracę'; break;
			case 'reviewrequest': result = 'Oczekujesz na opinię'; break;
			case 'done': result = 'Otrzymałeś opinię'; break;
			case 'markrequest': result = 'Oczekujesz na opinię'; break;
			case 'markadded': result = 'Otrzymałeś opinię'; break;
			case 'markrequestsent': result = 'Wysłałeś prośbę o opinię'; break;
			default: result = '';
		}
		return result;
	};

	RatingToNumber = (r) => {
		switch (r) {
			case 'markValueNegative': return 2;
			case 'markValueSecondStar': return 4;
			case 'markValueNeutral': return 6;
			case 'markValueFourthStar': return 8;
			case 'markValuePositive': return 10;
			default: return 0;
		}
	};

	SubmitConfirmMessage = {
		'ok': 'Dane zostały zapisane',
		'ok:reviews:ask': 'Wysłano prośbę o&nbsp;opinię',
		'ok:reviews:reply': 'Dodano odpowiedź na&nbsp;opinię',
		'ok:reviews:share': 'Skopiowano link do schowka',
		'fail:gallery:duplicate': 'To zdjęcie zostało już dodane!',
		'fail:reviews:time_limit': 'Możesz wysłać ponowną prośbę o&nbsp;opinie za&nbsp;%s',
		'fail:reviews:count_limit': 'Wysłałeś już maksymalną liczbę przypomnień na ten adres e-mail',
		'fail': 'Wpisz poprawne dane i&nbsp;spróbuj jeszcze raz!',
		'fail:uncover:not_enough_points': 'Nie posiadasz wystarczających środków',
		'fail:uncover:expired_points': 'Dostęp do danych kontaktowych Klientów wymaga aktywnego pakietu punktów',
		'fail:uncover:blocked': 'Limit odkryć został wykorzystany',
		'fail:uncover:uncovered': 'To zapytanie jest już odkryte',
		'fail:uncover:uncovered_group': 'Firma z Twojej Grupy rozpoczęła już proces składania oferty',
		'fail:uncover:uncover_limit': 'Limit złożonych ofert został osiągnięty',
		'fail:uncover:rfp_expired': 'Termin składania ofert już upłynął',
		'fail:uncover:rfp_sold': 'Zapytanie zostało już sprzedane',
		'fail:uncover:unknown': 'Wystąpił nieznany błąd',
		'ok:rfp:move:won': 'Przeniesiono do wygranych',
		'ok:rfp:move:archived': 'Przeniesiono do archiwum',
		'ok:rfp:move:received': 'Przeniesiono do przychodzących',
		'ok:partnership_sent': 'Wysłano prośbę o przystąpienie do programu partnerskiego',
	};

	TimeAgoInSeconds = (d: Date) => ((Number(new Date()) - Number(d)) / 1000).toFixed();

	TimeAgo = (s, style = 'normal', displayTime = true, useYesterday = false) => {
		// style = normal | short
		let styleStrings = {
			today: 'o ',
			yesterday: `1 dzień temu${displayTime ? ' o ' : ''}`,
			mins: ['minutę', 'minuty', 'minut'],
			hrs: ['godzinę', 'godziny', 'godzin'],
		};

		if (style === 'short') {
			styleStrings = {
				today: '',
				yesterday: `1 dzień temu${displayTime ? ', ' : ''}`,
				mins: ['min.', 'min.', 'min.'],
				hrs: ['godz.', 'godz.', 'godz.'],
			};
		}

		if (s < 0) { return 'teraz'; }
		s = parseInt(s, 10);
		if (s === 0) { return '3+ dni temu'; }
		const now = new Date() as any;
		const past = new Date(Date.now() - (s * 1000)) as any;
		const dateDiff = now.getDate() === past.getDate() ? 0 : now.getDayOfYear() - past.getDayOfYear();
		function time(d) {
			const h = d.getHours();
			const m = d.getMinutes();
			return `${(h < 10 ? '0' : '') + h}:${m < 10 ? '0' : ''}${m}`;
		}

		const formatDayResult = (s) => {
			if (!useYesterday) { return s; }
			if (s.startsWith('1 dzień temu')) {
				return s.replace('1 dzień temu', 'wczoraj');
			}
			if (s.startsWith('2 dni temu')) {
				return s.replace('2 dni temu', 'przedwczoraj');
			}
			return s;
		};

		if (dateDiff >= 7) { return formatDayResult(`${dateDiff} dni temu`); }
		if (dateDiff >= 2) { return formatDayResult(`${dateDiff} dni temu${(displayTime && useYesterday) ? `${style === 'short' ? ',' : ' o'} ${time(past)}` : ''}`); }
		if (dateDiff === 1) { return formatDayResult(styleStrings.yesterday + (displayTime ? time(past) : '')); }
		if (s > 12 * 60 * 60) { return styleStrings.today + (displayTime ? time(past) : ''); }
		if (s > 60 * 60) {
			const h = Math.floor(s / (60 * 60));
			return `${this.PluralForm(h, styleStrings.hrs, true)} temu`;
		}
		if (s > 0 && s < 60) { s = 60; }
		if (s >= 60) {
			s = Math.floor(s / (60));
			return `${this.PluralForm(s, styleStrings.mins, true)} temu`;
		}

		return '';
	};

	TimeAgoWithFraction = (n, dayLimit) => {
		let delta = n * 60;

		const d = Math.floor(delta / 86400);
		delta -= d * 86400;

		const h = Math.floor(delta / 3600) % 24;
		delta -= h * 3600;

		const m = Math.floor(delta / 60) % 60;
		delta -= m * 60;

		const result = (d ? (d + (d > 1 ? ' dni ' : ' dzień ')) : '') + (h ? (`${h} godz `) : '') + ((m && !d) ? (`${m} min `) : '');
		return (dayLimit && d > dayLimit) ? `${dayLimit}+ dni` : result;
	};

	formatDate = (date: Date, isISO: boolean) => {
		const year = date.getFullYear();
		const month = (date.getMonth() + 1).toString().padStart(2, '0');
		const day = date.getDate().toString().padStart(2, '0');

		return isISO ? `${year}-${month}-${day}` : `${day}.${month}.${year}`;
	};

	QuadraticEaseOut(currentTime: number, startValue: number, changeInValue: number, duration: number): number {
		const time = currentTime / duration;
		return -changeInValue * time * (time - 2) + startValue;
	};

	Currency(i: number | string, showSymbol = true): string {
		const value = Number(i);
		if (isNaN(value)) return '0,00';
		return new Intl.NumberFormat('pl-PL', {
			style: showSymbol ? 'currency' : 'decimal',
			currency: 'PLN',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
			useGrouping: true,
		}).format(value);
	};

	FormatPhoneNumberWithPrefix(phoneNumber: string) {
		if (!phoneNumber.startsWith('+48')) {
			return phoneNumber;
		}
		return phoneNumber.replace(/^(\+48)(\d{3})(\d{3})(\d{3})$/, '$1 $2 $3 $4');
	};

	Measure = [
		{ Value: 'kg', Label: 'kg' }, { Value: 'ton', Label: 'ton' },
		{ Value: 'm', Label: 'm' }, { Value: 'm²', Label: 'm²' }, { Value: 'm³', Label: 'm³' },
		{ Value: 'szt.', Label: 'szt.' }, { Value: 'litrów', Label: 'litrów' }, { Value: 'palet', Label: 'palet' },
	];

	static MinMobileLengths: Record<number, number> = {
		43: 7, // Austria
		32: 9, // Belgium
		359: 8, // Bulgaria
		385: 8, // Croatia
		357: 8, // Cyprus
		420: 9, // Czech Republic
		45: 8, // Denmark
		372: 7, // Estonia
		358: 9, // Finland
		33: 9, // France
		49: 7, // Germany
		30: 10, // Greece
		36: 9, // Hungary
		353: 9, // Ireland
		39: 9, // Italy
		371: 8, // Latvia
		370: 8, // Lithuania
		352: 9, // Luxembourg
		356: 7, // Malta
		31: 9, // Netherlands
		48: 9, // Poland
		351: 9, // Portugal
		40: 9, // Romania
		421: 9, // Slovakia
		386: 8, // Slovenia
		34: 9, // Spain
		46: 7, // Sweden
		44: 10, // United Kingdom
	};

	static MinMobilePhoneLengthByPrefix(prefix: number | string) {
		const prefixClean = Number(String(prefix).replace('+', '').replace('00', ''));

		return this.MinMobileLengths[prefixClean] ?? 7;
	};

	MinMobilePhoneLengthByPrefix(prefix: number | string) {
		const prefixClean = Number(String(prefix).replace('+', '').replace('00', ''));

		return Formatters.MinMobileLengths[prefixClean] ?? 7;
	};
}
